/* eslint-disable @typescript-eslint/no-unused-vars */
import { ComponentPropsWithoutRef, FC } from 'react';
import { Button } from '@rbx/ui';
import getComponentIsDeprecatedMsg from './getComponentIsDeprecatedMsg';

export interface DownloadStudioButtonProps extends ComponentPropsWithoutRef<typeof Button> {
  label?: string;
}

const DownloadStudioButton: FC<DownloadStudioButtonProps> = (_: DownloadStudioButtonProps) => {
  throw Error(
    getComponentIsDeprecatedMsg({
      deprecatedComponent: 'DownloadStudioButton',
      newComponentToUseInstead: 'UseStudioButton',
    }),
  );
};

export default DownloadStudioButton;
